import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Themed } from "@components/atoms/Themed"
import { ResponsiveImageFragment } from "../../types.graphql"
import { twMerge } from "tailwind-merge"
import { EditableText, InnerBlocks, usePostTitleEditor } from "eddev/blocks"
import { HeaderBasic } from "./HeaderBasic"
import { useEffect, useRef } from "react"
import { useRafLoop } from "react-use"
import Marquee from "react-fast-marquee"
import { Gradient } from "@components/motion/Gradient"

export const HeaderCarousel = ({
  title,
  theme,
  images,
}: {
  title?: string
  theme: string
  images?: (ResponsiveImageFragment | { aspect?: number | null; srcSet?: string | null } | null)[]
}) => {
  return (
    <>
      <Themed theme={theme} type="bg" className="w-full flex flex-col md:flex-row gap-4 py-4 justify-between relative">
        <Gradient
          theme={theme}
          className="absolute left-0 top-0 h-full bg-white"
          aspect="1/1"
          showImage={false}
          cutEdges={false}
          align="left"
          scale={1}
          // speed={0.5}
          bg={{ r: 1, g: 1, b: 1 }}
        />
        <div className="w-full h-pageHeaderPrimaryH shrink-0 flex gap-4 flex-nowrap justify-start items-center overflow-hidden relative">
          <Marquee
            className="h-full [&_.rfm-marquee]:w-fit [&_.rfm-initial-child-container]:h-full [&_.rfm-child]:h-full [&_.rfm-child]:w-fit"
            autoFill
          >
            {images?.map(
              (image, i) =>
                image && (
                  <div className="aspect-square h-full" key={i}>
                    <ResponsiveImage {...image} resizer={false} className="carousel-image h-full mr-4" />
                  </div>
                ),
            )}
          </Marquee>
        </div>
      </Themed>
      <HeaderBasic title={title} className="mt-8" hasTopSpacing={false} />
    </>
  )
}
